var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{class:{
        'p-2': _vm.dense
      },attrs:{"no-padding":_vm.noPadding || _vm.dense,"flat":!_vm.raised,"color":_vm.color}},[_c('div',{staticClass:"text-lg font-medium"},[_vm._t("title")],2),_c('div',{staticClass:"text-xs"},[_vm._t("subtitle")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }